module.exports = __webpack_public_path__ + "img/quality-control-schema.3b4dfcb1.png";